export const initialGeofenceModalCy = 'initial-geofence-modal';
export const geofenceApplyButtonCy = 'geofence-apply-button';
